var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAugmentReality(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#3F51B5;}\r\n\t.st1{fill:#283593;}\r\n\t.st2{fill:#02A9F4;}\r\n\t.st3{fill:#FFDC00;}\r\n\t.st4{fill:#FEC108;}\r\n\t.st5{fill:#FF9801;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_06---AR-Phone-Projection"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    className: "st0",
    d: "M503.5,452.3c-0.1,4.7-2.1,9.1-5.5,12.3s-7.9,4.9-12.6,4.8h-33.1l-16.1-36.8h-0.9l-24.9-4.2 c-6.2-1-11.4-5.4-13.4-11.4l-9.1-27.4c-2.7-8.1,0.9-16.9,8.5-20.7l9-4.5h0.9l-13.7-31.5h15.1c12.2-0.1,23.7,5.9,30.6,16l62.4,94.4 C502.5,445.9,503.5,449,503.5,452.3L503.5,452.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_1_",
    className: "st1",
    d: "M500.7,443.2l-62.4-94.4c-6.9-10.1-18.4-16.1-30.6-16l-15.1,0l0.8,1.8 c7.9,2.4,14.7,7.4,19.4,14.3l62.4,94.4c1.8,2.7,2.8,5.8,2.8,9c-0.1,4.7-2.1,9.1-5.5,12.3s-7.9,4.9-12.6,4.8h25.6 c4.7,0.1,9.2-1.6,12.6-4.8s5.4-7.6,5.5-12.3C503.5,449,502.5,445.9,500.7,443.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_2_",
    className: "st2",
    d: "M452.3,469.3h-384L128,332.8h20.7l39.1,59.7h136.5l39.1-59.7h29.2l13.7,31.5h-0.9l-9,4.5 c-7.6,3.8-11.3,12.7-8.5,20.7l9.1,27.4c2,6,7.2,10.4,13.4,11.4l24.9,4.2h0.9L452.3,469.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_3_",
    className: "st0",
    d: "M128,332.8L68.3,469.3H26.6c-4.7,0.1-9.2-1.6-12.6-4.8s-5.4-7.6-5.5-12.3c0-3.2,1-6.4,2.8-9 l62.4-94.4c6.9-10.1,18.4-16.1,30.6-16L128,332.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_4_",
    className: "st0",
    d: "M503.5,452.3v34.1c0,9.4-7.7,17-17.1,17.1H25.6c-9.4,0-17-7.7-17.1-17.1v-34.1 c0.1,4.7,2.1,9.1,5.5,12.3s7.9,4.9,12.6,4.8h458.8c4.7,0.1,9.2-1.6,12.6-4.8S503.3,456.9,503.5,452.3L503.5,452.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_5_",
    className: "st1",
    d: "M485.4,469.3h-7.5v17.1c0,9.4-7.7,17-17.1,17.1h25.6c9.4,0,17-7.7,17.1-17.1v-34.1 c-0.1,4.7-2.1,9.1-5.5,12.3S490,469.5,485.4,469.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_6_",
    className: "st3",
    d: "M366.9,68.3v119.5L256,247.5l-110.9-59.7V68.3L256,8.5L366.9,68.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_7_",
    className: "st4",
    d: "M256,8.5l-12.8,6.9l98.1,52.8v119.5l-98.1,52.8l12.8,6.9l110.9-59.7V68.3L256,8.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Shape_8_",
    className: "st5",
    d: "M286.1,102.1L256,118.3l-30.1-16.2c-4.2-2.2-9.3-0.7-11.6,3.5s-0.7,9.3,3.5,11.6l29.6,16v20.5 c0,4.7,3.8,8.5,8.5,8.5c4.7,0,8.5-3.8,8.5-8.5v-20.5l29.6-15.9c4.2-2.2,5.7-7.4,3.5-11.6C295.4,101.5,290.2,99.9,286.1,102.1 L286.1,102.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_9_",
    className: "st5",
    d: "M183.2,79.1l-34.1-18.3c-4.2-2.2-9.3-0.7-11.6,3.5s-0.7,9.3,3.5,11.6l34.1,18.3 c4.2,2.2,9.3,0.7,11.6-3.5S187.4,81.3,183.2,79.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_10_",
    className: "st5",
    d: "M374.5,64.2c-1.1-2-2.9-3.5-5.1-4.1c-2.2-0.7-4.5-0.4-6.5,0.7l-34.1,18.3 c-4.2,2.2-5.7,7.4-3.5,11.6s7.4,5.7,11.6,3.5L371,75.8c2-1.1,3.5-2.9,4.1-5.1C375.8,68.6,375.5,66.2,374.5,64.2L374.5,64.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_11_",
    className: "st5",
    d: "M256,196.3c-4.7,0-8.5,3.8-8.5,8.5v42.7c0,4.7,3.8,8.5,8.5,8.5c4.7,0,8.5-3.8,8.5-8.5v-42.7 C264.5,200.1,260.7,196.3,256,196.3z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Shape_12_",
    d: "M445.4,344.1c-8.5-12.5-22.6-20-37.7-19.8h-28.5l97.4-148.9c1.7-2.6,1.9-5.8,0.6-8.6 c-1.4-2.8-4.1-4.6-7.2-4.7c-3.1-0.2-6,1.4-7.6,4L319.7,384H192.3L49.8,166c-1.6-2.6-4.6-4.1-7.6-4c-3.1,0.2-5.8,2-7.2,4.7 c-1.4,2.8-1.2,6,0.6,8.6l97.4,148.9h-28.5c-15.1-0.1-29.3,7.3-37.8,19.9L4.3,438.4c-2.8,4.1-4.3,8.9-4.3,13.8v34.1 C0,500.5,11.5,512,25.6,512h460.8c14.1,0,25.6-11.5,25.6-25.6v-34.1c0-4.9-1.5-9.7-4.3-13.7L445.4,344.1z M133.6,341.3h10.5 l36.5,55.9c1.6,2.4,4.3,3.9,7.1,3.9h136.5c2.9,0,5.6-1.5,7.1-3.9l36.5-55.9h19l8.1,18.6l-2.6,1.3c-11.3,5.8-16.8,19-12.8,31 l9.1,27.4c3,9,10.7,15.7,20.1,17.2l21.4,3.6l9,20.4H81.3L133.6,341.3z M18.5,447.9l62.4-94.3c5.3-7.8,14.1-12.4,23.5-12.2H115 L62.7,460.8H26.6c-5,0.3-9.3-3.5-9.6-8.5C17.1,450.7,17.6,449.2,18.5,447.9z M494.9,486.4c0,4.7-3.8,8.5-8.5,8.5H25.6 c-4.7,0-8.5-3.8-8.5-8.5v-10.3c3.1,1.2,6.3,1.8,9.6,1.8h458.8c3.3,0,6.5-0.6,9.6-1.8L494.9,486.4z M485.4,460.8h-27.5L444,429.1 c-1.4-3.1-4.4-5.1-7.8-5.1l-24.5-4.1c-3.1-0.5-5.7-2.7-6.7-5.7l-9.1-27.4c-1.4-4,0.5-8.5,4.3-10.4l7.4-3.7c2.6-0.4,4.9-2,6.2-4.3 s1.4-5.1,0.4-7.5l-8.5-19.5h2.1c9.4-0.1,18.2,4.5,23.5,12.2l62.4,94.5c0.9,1.3,1.3,2.7,1.3,4.3 C494.6,457.3,490.4,461.1,485.4,460.8L485.4,460.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_13_",
    d: "M141,195.2L252,255c2.5,1.4,5.6,1.4,8.1,0L371,195.2c2.8-1.5,4.5-4.4,4.5-7.5V68.3c0-3.1-1.7-6-4.5-7.5 L260,1c-2.5-1.4-5.6-1.4-8.1,0L141,60.8c-2.8,1.5-4.5,4.4-4.5,7.5v119.5C136.5,190.9,138.3,193.8,141,195.2z M153.6,73.4L256,18.2 l102.4,55.2v109.2L256,237.8l-102.4-55.2V73.4z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAugmentReality);
export default __webpack_public_path__ + "static/media/augment-reality.9aa1c1d11e716b3619ee03589f37bd30.svg";
export { ForwardRef as ReactComponent };